"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import { Skeleton } from "@/components/ui/skeleton";
import { useCodiDetails } from "@/lib/queries/payment";
import { ErrorBanner } from "./error-banner";
import { InstructionContainer } from "./instruction-container";

export const CodiInstructions = () => {
  const t = useTranslations("instructions");
  const { data, isPending, isError, refetch } = useCodiDetails();

  return (
    <div className="space-y-8">
      {isError && <ErrorBanner refetch={refetch} />}
      <InstructionContainer isError={isError}>
        <div className="space-y-2">
          <p>{t("codi.intro1")}</p>
          <p>{t("codi.intro2")}</p>
        </div>
        {!isPending ? (
          <div className="flex w-full flex-col items-center space-y-1">
            <p className="font-semibold text-sm tabular-nums">
              {data?.reference}
            </p>
            {data?.image && (
              <div className="h-60 w-60 rounded-lg bg-white">
                <Image
                  width={256}
                  height={128}
                  className="h-56 w-56"
                  src={data.image}
                  alt={t("codi.qrAlt")}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="flex w-full flex-col items-center space-y-1">
            <Skeleton className="h-5 w-[200px] rounded-lg" />
            <Skeleton className="h-60 w-60 rounded-lg" />
          </div>
        )}
        <p className="text-muted text-sm">
          {t.rich("help", {
            email: (chunks) => (
              <a className="text-accent" href="mailto:info@paycode.com.mx">
                {chunks}
              </a>
            ),
            phone: (chunks) => (
              <a className="text-accent" href="tel:+525624870068">
                {chunks}
              </a>
            ),
          })}
        </p>
      </InstructionContainer>
    </div>
  );
};
